import { createAction, props } from '@ngrx/store';

export const mapToggle = createAction('[Map] toggle map', props<{ enabled: boolean }>());
export const mapUpdate = createAction('[Map] update', props<{ payload: any }>());
export const mapSaveData = createAction('[Map] save map data');
export const mapSkip = createAction('[Map] skip');
